import React, { useCallback, useEffect, useState, useRef } from 'react';
function useReveal(delay = 0) {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setTimeout(() => el.classList.add('in-view'), delay);
        observer.disconnect();
      }
    }, {
      threshold: 0.05
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, [delay]);
  return ref;
}
export function Footer() {
  const ctaRef = useReveal();
  const bottomRef = useReveal(200);
  return <footer id="contact" className="w-full pt-24 pb-10" style={{
    '--bg': '#E18161',
    '--fg': '#171716',
    '--muted': '#4A2A1E',
    '--border': 'rgba(23, 23, 22, 0.2)',
    background: 'var(--bg)'
  } as React.CSSProperties} data-id="element-64" data-mp="3j3zzhj5u87ik">
      <div className="content-wrap px-6 md:px-12" data-id="element-65" data-mp="3f2ej3nu3hb3m">
        {/* Big CTA */}
        <div className="relative pt-16 mb-20" data-id="element-66" data-mp="279aq6etu3fb2">
          <div ref={ctaRef} className="reveal" data-id="element-67" data-mp="239jym8whgv5h">
            <div className="flex flex-col md:flex-row md:items-end justify-between gap-8" data-id="element-68" data-mp="238qu7ekzyhqi">
              <div className="flex flex-col gap-4 max-w-3xl" data-id="element-69" data-mp="2h8jdiou71vog">
                <h2 className="font-serif text-3xl md:text-[clamp(2.75rem,6vw,4.5rem)] tracking-tight leading-tight" style={{
                color: 'var(--fg)'
              }} data-id="element-70" data-mp="2c9glq6385lyf">
                  Have an idea worth building?
                </h2>
                <p className="mt-2 text-base md:mt-4 md:text-lg max-w-xl" style={{
                color: 'var(--muted)'
              }} data-id="element-71" data-mp="1yagtypkf0qy1">
                  I'm open to product advisory, strategy, and design
                  partnerships with early-stage teams.
                </p>
              </div>
              <div className="mt-6 md:mt-0" data-id="element-72" data-mp="30x2j14m3l7x8">
                <button data-cal-link="go.launch/30min" data-cal-namespace="30min" data-cal-config='{"layout":"month_view","useSlotsViewOnSmallScreen":"true"}' className="font-aspekta inline-flex items-center gap-2 whitespace-nowrap text-base font-normal px-8 py-4 rounded-full cursor-pointer transition-colors duration-150 ease-out group" style={{
                background: '#171716',
                color: '#F7F5EE',
                border: 'none'
              }} onMouseEnter={e => {
                e.currentTarget.style.background = '#2E2D2A';
              }} onMouseLeave={e => {
                e.currentTarget.style.background = '#171716';
              }} data-id="element-73" data-mp="30vzw17rwbpml">
                  Book a call
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Footer bottom */}
        <div ref={bottomRef} className="reveal flex flex-col md:flex-row items-start md:items-center justify-between gap-8 border-t pt-8" style={{
        borderColor: 'var(--border)'
      }} data-id="element-74" data-mp="lamc9lwqe41o">
          <div className="flex flex-col gap-3" data-id="element-75" data-mp="bjhxonaywl7d">
            <span className="font-aspekta text-xl tracking-tight" style={{
            color: 'var(--fg)'
          }} data-id="element-76" data-mp="7j7svdyww0u3">
              Stella Pangilinan
            </span>
            <span className="text-xs md:text-sm" style={{
            color: 'var(--muted)'
          }} data-id="element-77" data-mp="3tr7orcoknf9j">
              © {new Date().getFullYear()} Stella Pangilinan. All rights reserved.
            </span>
          </div>
          <div className="flex flex-wrap items-center gap-x-5 gap-y-2 md:gap-6" data-id="element-78" data-mp="1n114sqro58b7">

            <a href="#" onClick={e => {
            e.preventDefault();
            window.scrollTo({
              top: 0,
              behavior: 'smooth'
            });
          }} className="text-xs md:text-sm font-medium transition-colors duration-200 md:ml-4" style={{
            color: 'var(--fg)'
          }} onMouseEnter={e => e.currentTarget.style.opacity = '0.7'} onMouseLeave={e => e.currentTarget.style.opacity = '1'} data-id="element-79" data-mp="1myorws0rpo50">
              Back to top ↑
            </a>
          </div>
        </div>
      </div>
    </footer>;
}